import { Grid, makeStyles, Theme, TextField, MenuItem } from "@material-ui/core";
import React, { FunctionComponent, useContext } from "react";
import { useTranslation } from "react-i18next";
import { DietPreference, Ethnicity } from "../../../api/smartmelts-api/graphql/generated";
import { NumberField } from "../../../components/fields/number-field";
import { DARK_TEXT_COLOR } from "../../../theme/theme";
import { OnboardingContext } from "../context/onboarding-context";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: theme.spacing(2),
  },
  detailWrapper: {
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),

    "& .MuiFormLabel-root": {
      color: DARK_TEXT_COLOR,
      fontWeight: 700,
    },
  },
}));

interface IOnboardingDetailsProps {}

export const OnboardingDetails: FunctionComponent<IOnboardingDetailsProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    setHeight,
    height,
    heightValid,
    setWeight,
    weight,
    weightValid,
    setEthnicity,
    ethnicity,
    ethnicityValid,
    setDietPreference,
    dietPreference,
    dietPreferenceValid,
  } = useContext(OnboardingContext);

  return (
    <Grid container justify="space-between" className={classes.container}>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <NumberField
          label={t("onboarding.weight.label")}
          fullWidth
          onChangeNumber={(value) => setWeight(value)}
          value={weight}
          error={!!weight && !weightValid}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <NumberField
          label={t("onboarding.height.label")}
          fullWidth
          onChangeNumber={(value) => setHeight(value)}
          autoFocus
          value={height}
          error={!!height && !heightValid}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          label={t("onboarding.ethnicity.label")}
          fullWidth
          select
          id="onboarding-ethnicity-select"
          value={ethnicity}
          error={!ethnicityValid}
          onChange={(event) => setEthnicity(event.target.value as Ethnicity)}
          autoFocus
        >
          {Object.keys(Ethnicity).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`ethnicity.${Ethnicity[key]}`)}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          label={t("onboarding.diet_preference.label")}
          fullWidth
          select
          id="onboarding-ethnicity-select"
          value={dietPreference}
          error={!dietPreferenceValid}
          onChange={(event) => setDietPreference(event.target.value as DietPreference)}
          autoFocus
        >
          {Object.keys(DietPreference).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`diet_preference.${DietPreference[key]}`)}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>
    </Grid>
  );
};
